import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import localStorageAvailable from '../utils/localStorageAvailable';
import { defaultLang } from './config-lang';
import plLocales from './langs/pl';

// ----------------------------------------------------------------------

// Polish, always. Neither a language stored from before English was withdrawn
// nor an English browser may pick anything else, so the detector is not asked.
const lng = defaultLang.value;

if (localStorageAvailable()) {
  // Overwrite rather than read: a leftover 'en' would otherwise sit in storage
  // and take effect again the moment another language is offered.
  localStorage.setItem('i18nextLng', lng);
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translations: plLocales },
    },
    lng,
    fallbackLng: defaultLang.value,
    supportedLngs: ['pl'],
    nonExplicitSupportedLngs: true,
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
    // No `detection` block: detection exists to pick between languages, and
    // there is only one.
  });

export default i18n;
